import { getTokenCompanyCode } from '@/utils/clientToken'
import { normalizeCompanyCode } from '@/utils/companyCode'

export const DEMO_COMPANY_CODE = 'DEMO'
// 예전부터 함께 인정해 온 스키마 접두 형태. 이제 normalizeCompanyCode 가 접두를 벗겨 DEMO 로 맞춰 주므로
// 비교에 직접 쓰지는 않지만, 외부로 export 된 상수라 그대로 둔다(허용 형태를 문서화하는 역할).
export const DEMO_COMPANY_SCHEMA = 'COMPANY_DEMO'
export const DEMO_COMPANY_NAME = '데모'

// DEMO / COMPANY_DEMO 를 둘 다 인정하던 기존 동작을 접두 제거 규칙으로 일반화한 것이라 판정 결과는 같다
// (COMPANY_DEMO → DEMO). company_DEMO 처럼 원본 대소문자 그대로 오는 경우까지 함께 커버된다.
export const isDemoCompanyCode = (companyCode) => {
  return normalizeCompanyCode(companyCode) === DEMO_COMPANY_CODE
}

export const isDemoCompanyName = (companyName) => {
  return String(companyName || '').trim() === DEMO_COMPANY_NAME
}

// 판별에 사용할 company_code를 우선순위대로 "하나만" 선택한다(exkrCompany.js와 동일 규칙).
// 데모 로그인도 client_token의 companyCode 클레임이 DEMO이므로 JWT 한 경로로 판별된다.
// localStorage는 쓰지 않는다: 로그아웃/타 회사 로그인 후에도 남는 잔존값이라 다른 회사를 데모로 오판했다.
// 이전 OR(.some()) 방식은 소스 하나만 DEMO여도 DEMO로 판정하는 구조라 그 잔존값이 그대로 결론이 됐다.
const resolveCompanyCode = (store) => {
  const loginBody = store?.getLoginData?.response?.body || store?.loginData?.response?.body || {}
  return (
    getTokenCompanyCode() ||
    store?.getCompanyCode ||
    store?.companyCode ||
    loginBody.company_code ||
    loginBody.companyCode
  )
}

export const isDemoCompanyContext = (store) => {
  const companyCode = resolveCompanyCode(store)
  if (companyCode) {
    return isDemoCompanyCode(companyCode)
  }

  // 회사 코드를 전혀 못 구했을 때만 회사명으로 보조 판별한다(구 버전은 코드와 OR 였다).
  // OR을 유지하면 안 되는 이유: logout()이 Pinia store를 초기화하지 않고 setLoginData가 이전 body에
  // spread 병합하므로, 데모 세션의 company_name('데모')이 다음 로그인 세션까지 남을 수 있다.
  // 그 상태로 OR을 태우면 서버 서명값이 다른 회사인데도 데모로 오판한다.
  const loginBody = store?.getLoginData?.response?.body || store?.loginData?.response?.body || {}
  return isDemoCompanyName(loginBody.company_name)
}
